 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML01_COVER from '@/components/html/01_cover'
 import HTML029_QUOTES from '@/components/html/029_quotes'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML002_TP from '@/components/html/002_tp'
 import HTML003_CR from '@/components/html/003_cr'
 import HTML004_DEDICATION from '@/components/html/004_dedication'
 import HTML005_MAP from '@/components/html/005_map'
 import HTML006_EPIGRAPH from '@/components/html/006_epigraph'
 import HTML007_TOC from '@/components/html/007_toc'
 import HTML008_LOI from '@/components/html/008_loi'
 import HTML009_HT from '@/components/html/009_ht'
 import HTML010_IL1 from '@/components/html/010_il1'
 import HTML011_C1 from '@/components/html/011_c1'
 import HTML012_IL2 from '@/components/html/012_il2'
 import HTML013_C2 from '@/components/html/013_c2'
 import HTML014_IL3 from '@/components/html/014_il3'
 import HTML015_C3 from '@/components/html/015_c3'
 import HTML016_IL4 from '@/components/html/016_il4'
 import HTML017_C4 from '@/components/html/017_c4'
 import HTML018_IL5 from '@/components/html/018_il5'
 import HTML019_C5 from '@/components/html/019_c5'
 import HTML020_IL6 from '@/components/html/020_il6'
 import HTML021_C6 from '@/components/html/021_c6'
 import HTML022_IL7 from '@/components/html/022_il7'
 import HTML023_C7 from '@/components/html/023_c7'
 import HTML024_IL8 from '@/components/html/024_il8'
 import HTML025_C8 from '@/components/html/025_c8'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML026_BIBLIIO from '@/components/html/026_bibliio'
 import HTML027_PERSONAL from '@/components/html/027_personal'
 import HTML028_PERMISSION from '@/components/html/028_permission'
 import HTML030_ABOUTTHEAUTHOR from '@/components/html/030_abouttheauthor'
 import HTMLADS from '@/components/html/ads'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/01_cover",
 			"name" : "html/01_cover",
 			"component" : HTML01_COVER
 		},
 		{
 			"path" : "/html/029_quotes",
 			"name" : "html/029_quotes",
 			"component" : HTML029_QUOTES
 		},
 		{
 			"path" : "/html/love_1",
 			"name" : "html/love_1",
 			"component" : HTMLLOVE_1
 		},
 		{
 			"path" : "/html/002_tp",
 			"name" : "html/002_tp",
 			"component" : HTML002_TP
 		},
 		{
 			"path" : "/html/003_cr",
 			"name" : "html/003_cr",
 			"component" : HTML003_CR
 		},
 		{
 			"path" : "/html/004_dedication",
 			"name" : "html/004_dedication",
 			"component" : HTML004_DEDICATION
 		},
 		{
 			"path" : "/html/005_map",
 			"name" : "html/005_map",
 			"component" : HTML005_MAP
 		},
 		{
 			"path" : "/html/006_epigraph",
 			"name" : "html/006_epigraph",
 			"component" : HTML006_EPIGRAPH
 		},
 		{
 			"path" : "/html/007_toc",
 			"name" : "html/007_toc",
 			"component" : HTML007_TOC
 		},
 		{
 			"path" : "/html/008_loi",
 			"name" : "html/008_loi",
 			"component" : HTML008_LOI
 		},
 		{
 			"path" : "/html/009_ht",
 			"name" : "html/009_ht",
 			"component" : HTML009_HT
 		},
 		{
 			"path" : "/html/010_il1",
 			"name" : "html/010_il1",
 			"component" : HTML010_IL1
 		},
 		{
 			"path" : "/html/011_c1",
 			"name" : "html/011_c1",
 			"component" : HTML011_C1
 		},
 		{
 			"path" : "/html/012_il2",
 			"name" : "html/012_il2",
 			"component" : HTML012_IL2
 		},
 		{
 			"path" : "/html/013_c2",
 			"name" : "html/013_c2",
 			"component" : HTML013_C2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js